import React, { useState, useEffect } from 'react';

export default function CountdownTimer({ scheduleHour, scheduleMinute }) {
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0, isToday: true });

  useEffect(() => {
    function calculateTimeLeft() {
      const now = new Date();
      let nextRun = new Date(now);
      nextRun.setHours(scheduleHour, scheduleMinute, 0, 0);
      if (nextRun <= now) {
        nextRun = new Date(now);
        nextRun.setDate(now.getDate() + 1);
        nextRun.setHours(scheduleHour, scheduleMinute, 0, 0);
      }
      const diff = nextRun - now;
      const hours = Math.floor(diff / 3_600_000);
      const minutes = Math.floor((diff % 3_600_000) / 60_000);
      const seconds = Math.floor((diff % 60_000) / 1_000);
      const isToday = nextRun.getDate() === now.getDate();
      setTimeLeft({ hours, minutes, seconds, isToday });
    }

    calculateTimeLeft();
    const timerId = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timerId);
  }, [scheduleHour, scheduleMinute]);

  const fmt = n => String(n).padStart(2, '0');

  return (
    <div className="text-gray-700 dark:text-gray-300">
      {timeLeft.isToday
        ? `Today's news in: ${fmt(timeLeft.hours)}h ${fmt(timeLeft.minutes)}m ${fmt(timeLeft.seconds)}s`
        : `Tomorrow's news in: ${fmt(timeLeft.hours)}h ${fmt(timeLeft.minutes)}m ${fmt(timeLeft.seconds)}s`
      }
    </div>
  );
}